interface IProgressBarProps {
  color?: string;
  backgroundColor?: string;
  progress: number;
  className?: string;
  height?: string;
  styleColor?: string;
}

export function ProgressBar({
  color,
  backgroundColor,
  progress,
  className = '',
  height = '4px',
  styleColor
}: IProgressBarProps) {
  if (progress > 100) {
    progress = 100;
  }

  if (progress <= 0) {
    progress = 1;
  }

  const backgroundColorClass = backgroundColor
    ? `bg-${backgroundColor}`
    : 'bg-mono-color-white';
  const colorClass = color ? `bg-${color}` : 'bg-brand-color-primary-pure';
  const newClassName = `h-[${height}] rounded-lg ${backgroundColorClass} shadow-level-1 ${className}`;

  return (
    <div className={newClassName}>
      <div
        className={`rounded-lg ${colorClass}`}
        style={{ width: `${progress}%`, height, backgroundColor: styleColor }}
      ></div>
    </div>
  );
}
